<template>
  <div class="myCouponsList">
    <div class="new-wrap" v-if="listShow">
      <div class="title">最新领取的服务券</div>
      <div class="body">
        <div>
          {{ upCouponLatest.couponStartTime }}至{{
            upCouponLatest.couponEndTime
          }}
        </div>
        <div>{{ upCouponLatest.couponName }}</div>
        <div>
          <div>
            <div>
              ￥<span>{{ upCouponLatest.totalAmount }}</span>
            </div>
            <div>总金额</div>
          </div>
          <div>
            <div>
              ￥<span>{{ upCouponLatest.useAmount }}</span>
            </div>
            <div>已用额度</div>
          </div>
          <div>
            <div>
              ￥<span>{{ upCouponLatest.restAmount }}</span>
            </div>
            <div>剩余可用</div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-wrap" v-if="listShow">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad(1)"
      >
        <div
          class="mylist"
          :class="[
            { mylist1: item.useStatus == 0 },
            { mylist2: item.useStatus == 2 }
          ]"
          v-for="item in mylists"
          :key="item.id"
        >
          <div class="list" @click="detailsTap(item.id)">
            <div class="list-title">{{ item.couponName }}</div>
            <div class="list-type">{{ item.couponTypeName }}</div>
            <div class="list-time">{{ item.time }}</div>
            <div class="list-status-text" v-if="item.useStatusText">
              {{ item.useStatusText }}
            </div>
          </div>
          <div
            class="list-status"
            :class="{ 'list-noStatus': item.useStatusText }"
            @click="goProductList(item.couponTypeName)"
          >
            <div class="list-num">
              ￥<span>{{ item.totalAmount }}</span>
            </div>
            <div v-if="!item.useStatusText">立即使用</div>
          </div>
        </div>
      </van-list>
    </div>
    <van-empty
      v-if="!listShow"
      class="custom-image"
      :image="require('../../../assets/coupons-none.png')"
      description="暂无数据"
    />
  </div>
</template>

<script>
import { listEntCoupon, entLatestCoupon } from '@api/coupons/index'
import { Toast } from 'vant'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { getLocalStorage } from '@utils'
export default {
  name: 'MyList',
  data() {
    return {
      listShow: true, // 是否无数据显示空状态
      finished: false,
      loading: true,
      mylists: [], // 我的服务券
      pageNum: 1,
      pageSize: 10,
      upCouponLatest: null,
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  created() {},
  mounted() {
    this.entLatestCoupon()
    this.getMyCoupon()
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    // 服务券列表加载更多
    onLoad(e) {
      this.pageNum++
      this.getMyCoupon()
    },
    // 服务券详情
    detailsTap(id) {
      this.buriedPoint()
      this.$router.push({
        path: '/coupons/details',
        query: {
          id: id
        }
      })
    },
    goProductList(type) {
      this.$router.push({
        path: '/market/index',
        query: {
          type
        }
      })
    },
    // 获取我的服务券
    getMyCoupon(num) {
      if (num) {
        this.pageNum = 1
        this.mylists = []
        this.loading = true
        this.finished = false
        this.listShow = true
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      listEntCoupon(params).then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          this.loading = false
          data.results.forEach(item => {
            let useStatusText = ''
            switch (item.useStatus) {
              case 0:
                useStatusText = '未开始'
                break
              case 2:
                useStatusText = '已过期'
                break
            }
            if (item.couponStartTime && item.couponEndTime) {
              let arr = {
                ...item,
                useStatusText: useStatusText,
                time:
                  '有效期：' +
                  item.couponStartTime.split(' ')[0] +
                  '至' +
                  item.couponEndTime.split(' ')[0]
              }
              this.mylists.push(arr)
            }
          })
          if (data.results.length < this.pageSize) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.mylists.length == 0) {
            this.listShow = false
          } else {
            this.listShow = true
          }
        } else {
          Toast(msg)
        }
      })
    },
    entLatestCoupon() {
      entLatestCoupon().then(res => {
        if (res.data.code == '0000') {
          this.upCouponLatest = res.data.data
          this.upCouponLatest.couponStartTime = this.timeHandle(
            this.upCouponLatest.couponStartTime
          )
          this.upCouponLatest.couponEndTime = this.timeHandle(
            this.upCouponLatest.couponEndTime
          )
        } else {
          Toast(res.data.msg)
        }
      })
    },
    // 时间处理
    timeHandle(m) {
      const time = m.split(' ')[0]
      const days = time.split('-')
      return days[0] + '年' + days[1] + '月' + days[2] + '日'
    }
  }
}
</script>
<style lang="scss" scoped>
.myCouponsList {
  width: 100%;
  height: 100vh;
  overflow: scroll;
  background: url('../../../assets/enterprise/coupons/background@4x.png')
    no-repeat;
  background-size: 100% 100%;
  padding: 10px 15px 0;
  box-sizing: border-box;
  .new-wrap {
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 5px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    padding: 20px 15px;
    margin-bottom: 20px;
    .title {
      font-size: 18px;
      color: rgba(51, 51, 51, 100);
      display: flex;
      align-items: center;
      font-weight: 600;
      &::before {
        width: 4px;
        height: 16px;
        content: '';
        display: inline-block;
        border-radius: 2px;
        background-color: rgba(0, 112, 255, 1);
        margin-right: 5px;
      }
    }
    .body {
      margin-top: 16px;
      padding: 12px;
      border-radius: 5px;
      background: linear-gradient(to right, #00c0ec, #0053ff);
      & > div:nth-child(2) {
        font-size: 17px;
        color: rgba(255, 255, 255, 100);
        margin-bottom: 20px;
      }
      & > div:nth-child(3) {
        display: flex;
        > div {
          width: 33.3%;
          text-align: center;
          span {
            font-size: 20px;
            color: rgba(255, 255, 255, 100);
          }
        }
      }
    }
  }
  .mylist {
    box-sizing: border-box;
    display: flex;
    margin: 0 0 15px;
    .list {
      background: #fff;
      /*       border-radius: 6px; */
      overflow: hidden;
      padding: 15px;
      position: relative;
      flex: 1;
      border-radius: 5px 0 0 5px;
      &-title {
        font-size: 15px;
        font-weight: bold;
        margin-top: 2px;
      }
      &-type {
        font-size: 12px;
        color: #999;
        margin: 6px 0 10px;
        border: 1px solid rgba(153, 153, 153, 1);
        display: inline-block;
        padding: 1px 4px;
      }
      &-time {
        font-size: 12px;
        color: #999;
      }
      &-status-text {
        font-size: 10px;
        border-radius: 5px;
        background-color: rgba(243, 243, 243, 1);
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        color: rgba(153, 153, 153, 100);
      }
    }
    .list-status {
      width: 70px;
      padding: 0 5px;
      color: #fff;
      background: #0080ff;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 0 5px 5px 0;
      .list-num {
        font-size: 14px;
        span {
          font-size: 17px;
          font-weight: bold;
        }
      }
    }
    .list-noStatus {
      background: rgba(212, 212, 212, 1);
      color: #fff;
    }
  }
  .mylist1 {
    .mylist-title {
      color: #999;
    }
    .mylist-num {
      color: #999;
    }
  }
  .mylist2 {
    .mylist-title {
      color: #999;
    }
    .mylist-status {
      background: #ff6600;
    }
    .mylist-num {
      color: #999;
    }
  }
}
</style>
